export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-usuario' */ '@/views/web-service/usuario/Index'),
        path: 'usuario',
        redirect: 'usuario/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-usuario' */'@/views/web-service/usuario/List.vue'),
                name: 'web-service-usuario-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-usuario' */ '@/views/web-service/usuario/Form.vue'),
                name: 'web-service-usuario-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-usuario' */ '@/views/web-service/usuario/Form.vue'),
                name: 'web-service-usuario-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]